import { Wallet } from 'lucide-react';
import { cn } from '../../lib/utils';
import { BUDGET_OPTIONS } from './tripConstants';

export const BudgetStep = ({ formData, updateFormData }) => (
  <div className="space-y-4">
    <div className="flex items-center gap-3 mb-3">
      <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-gold to-ocean flex items-center justify-center text-white shadow-lg">
        <Wallet className="w-5 h-5" />
      </div>
      <div>
        <h3 className="text-lg font-semibold text-ocean">What's your budget?</h3>
        <p className="text-ocean/70 text-xs">Choose your spending comfort level</p>
      </div>
    </div>
    <div className="grid md:grid-cols-3 gap-3">
      {BUDGET_OPTIONS.map((option) => (
        <button key={option.value}
          onClick={() => updateFormData('budget', option.value)}
          className={cn('p-4 rounded-xl border-2 transition-all duration-300 text-center backdrop-blur-sm',
            formData.budget === option.value
              ? 'border-gold bg-gradient-to-br from-gold/20 to-ocean/10 shadow-xl scale-105'
              : 'border-ocean/20 bg-white/50 hover:border-gold/50 hover:shadow-lg hover:bg-white/70')}
          data-testid={`budget-${option.value}`}>
          <span className="text-2xl mb-1.5 block">{option.icon}</span>
          <span className="font-semibold text-ocean block text-base mb-0.5">{option.label}</span>
          <span className="text-xs text-ocean/60">{option.desc}</span>
        </button>
      ))}
    </div>
  </div>
);
